export default __webpack_public_path__ + "static/media/232.57ae281e.jpg";